var applyFlatpickr = function () {
  $('[data-flatpickr]').not('[data-flatpickr-initialized]').each(function () {
    var $node = $(this);

    if (!$node.data('flatpickr').initialized) {
      var uses_time = $node.data('flatpickr-enabletime');
      var uses_date = $node.data('flatpickr-enabledate');

      if (typeof uses_time === 'undefined') uses_time = false;
      if (typeof uses_date === 'undefined') uses_date = true;

      if (uses_time && uses_date) {
        altFormat = "Y-m-d h:i K"
      } else if (uses_time) {
        altFormat = "h:i K"
      } else {
        altFormat = "Y-m-d"
      }

      console.log(`Time: ${uses_time}, Date: ${uses_date}, Format: ${altFormat}`);

      if (uses_time == true) {

        $node.flatpickr(
          {
            disableMobile: true,
            noCalendar: !uses_date,
            enableTime: uses_time,
            altInput: true,
            altFormat: altFormat,
            dateFormat: "Y-m-d H:i"
          }
        );
      } else {
        $node.flatpickr({disableMobile: true});
      }

      $node.data('flatpickr').initialized = true;
    }
  });
};
$(document).ready(applyFlatpickr);

$(document).ready(function () {
  $('.flatpickr-container').on('cocoon:after-insert', function (e, insertedItem) {
    insertedItem.find('[data-flatpickr]').flatpickr({disableMobile: true});
    $('.birthday-app').on('focus', ({ currentTarget }) => $(currentTarget).blur())
    $('.birthday-app').prop('readonly', false)
  });
  $('.birthday-app').on('focus', ({ currentTarget }) => $(currentTarget).blur())
  $('.birthday-app').prop('readonly', false)
})

// reenable if turning turbolinks back on
// document.addEventListener('turbolinks:load', applyFlatpickr);
